<template>
    <div>
        <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="120px">
            <el-form-item v-if="rule.virtual_device_id==''" label="真实设备号码" prop="hardware_device_id">
                <el-button type="default" @click="openDialog">{{rule.hardware_device_id == ''? '搜索设备':rule.hardware_device_id}}</el-button>
            </el-form-item>
            <el-form-item v-else label="真实设备号码" prop="hardware_device_id">
                {{rule.hardware_device_id}}
            </el-form-item>
            <el-form-item v-if="rule.virtual_device_id!=''" label="虚拟设备号码" prop="hardware_device_id">
                {{rule.virtual_device_id}}
            </el-form-item>
            <el-form-item label="起始时间" prop="start_time">
                <el-date-picker
                    v-model="rule.start_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy/MM/dd HH:mm:ss"
                    placeholder="起始时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="permanent">
                <el-radio-group v-model="rule.permanent" @change="onPermanent" v-if="rule.virtual_device_id==0">
                    <el-radio :label="true">永久有效</el-radio>
                    <el-radio :label="false">自定义</el-radio>
                </el-radio-group>
                <div v-else>{{rule.permanent?'永久有效':'自定义'}}</div>
            </el-form-item>
            <el-form-item label="结束时间" prop="end_time" v-if="!rule.permanent">
                <el-date-picker
                    v-if="rule.virtual_device_id==0"
                    v-model="rule.end_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy/MM/dd HH:mm:ss"
                    placeholder="结束时间">
                </el-date-picker>
                <div v-else>{{rule.end_time}}</div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>


        <el-dialog title="搜索设备" :visible.sync="open">
            <el-row class="dialog_bar" :gutter="15">
                <el-col :span="10">
                    <el-input placeholder="真实设备号码" v-model="devId"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
                </el-col>
            </el-row>
            <el-radio-group class="radio_group_column" v-model="radio">
                <el-radio v-for="item in radioGroup" :label="item.id" :key="item.id">{{item.devAlias}}</el-radio>
            </el-radio-group>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDailog">取 消</el-button>
                <el-button type="primary" @click="addRadio">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: false,
                devId: '',
                rule: {
                    end_time: '',
                    hardware_device_id:'',
                    name: '',
                    permanent:true,
                    start_time: '',
                    virtual_device_id:0
                },
                rules: {
                    hardware_device_id: { required: true, message: '请选择真实设备号码' },
                    end_time: {required: false, message: '请选择结束时间'},
                    start_time: {required: true, message: '请选择起始时间'},
                },
                radioGroup:[],
                radio:''
            }
        },
        async created() {
            if(this.$route.params.id) {
                if(this.$store.state.editInfo.length == 0) {
                    this.$router.push('/equipment/virtual');
                }else {
                    this.rule.hardware_device_id = this.$store.state.editInfo.hardware_device_id
                    this.rule.end_time = this.$store.state.editInfo.end_time
                    this.rule.permanent = this.$store.state.editInfo.permanent
                    this.rule.start_time = this.$store.state.editInfo.start_time
                    this.rule.virtual_device_id = this.$store.state.editInfo.virtual_device_id
                }
            }
        },
        methods:{
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.virtual_device_id == 0) {
                            this.$http.post('/manage/virtual_device/add',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/equipment/virtual');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.$http.post('/manage/virtual_device/update',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/equipment/portable/virtual');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            block() {
                this.$router.push('/equipment/portable/virtual/index');
            },
            onSearch() {
                if(this.devId != '') {
                    this.$http.get('/manage/virtual_device/list_hd',{params:{'hardware_device_id': this.devId}}).then(({data})=>{
                        this.radioGroup = data.data;
                    });
                }
            },
            openDialog() {
                this.open = true;
                this.devId = '';
                this.radioGroup = []
                this.radio = '';
            },
            closeDailog() {
                this.open = false;
                this.devId = '';
                this.radioGroup = []
                this.radio = '';
            },
            addRadio() {
                this.open = false;
                this.devId = '';
                this.rule.hardware_device_id = this.radio;
            },
            onPermanent() {
                this.rules.end_time.required = !this.rule.permanent
            }
        }
    }
</script>

<style scoped>
.dialog_bar{
    margin-bottom: 20px;
}
.radio_group_column{
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    max-height: 300px;
    overflow-y: auto;
}
.radio_group_column label{
    margin-bottom: 10px;
}
</style>